import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

export default class FlowBCDT {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllCompanies(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/company?page=0&size=10000", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllCompaniesV2(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/companyV2", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getPeriodCpn(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/get-company-by-finan-period?finance-id=" + querySearch.id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getBusinessCpn(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/company-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getTypeOfDispatch(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/doc/bcdt-doc-types")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getLicNumber(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/lic-number")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getLicNumberV2(query): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/v2/lic-number", {
          params: query,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // public getUserName(): Promise<any> {
  //   return new Promise<any>((resolve, reject) => {
  //     axios
  //       .get(baseURL + `/api/auth/users/usernames`)
  //       .then((res) => {
  //         resolve(res.data);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //       });
  //   });
  // }
  public get_importers(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/auth/users/usernames")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getNetwork(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/network-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public UploadFile(file): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/file-bcdt-parser`, file)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllserviceSearch() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/telcoService/businessSearch")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public LicCpnLicensee() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/lic-cpn-licenses")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getFile(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiFile + id)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public BCDT_CV(querySearch: any, checksms: boolean): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/doc/bcdt-ntf-doc-dn?send_sms=${checksms}`, querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  public SearchBCDT(querySearch: any, cancelToken): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/search-bcdt", querySearch, { cancelToken: cancelToken.token })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public SearchBCDT_V2(querySearch: any, cancelToken): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/v2/search-bcdt", querySearch, { cancelToken: cancelToken.token })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public SearchHisBCDT(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/search-bcdt-history", querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public bcdtOverview(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/bcdt-overview", querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public excelBcdt(querySearch?: any, type?: Number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/search-bcdt-excel?type=${type}`, querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public PaidBcdt(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/company-has-paid-bcdt", querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public paidBcdtOnTime(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/company-has-paid-bcdt-on-time", querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public paidBcdtOvertime(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(" /api/business/company-has-paid-bcdt-overtime", querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public hasNotPaidBcdt(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/company-has-not-paid-bcdt", querySearch)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
}
